import { apiFetch } from "./client";

export type VariableType = "string" | "number" | "boolean";

export interface Template {
  templateId: string;
  name: string;
  subject: string;
  htmlBody: string;
  textBody?: string;
  variableSchema: Record<string, VariableType>;
  createdAt: string;
  updatedAt: string;
}

export const templatesApi = {
  list: () => apiFetch<{ templates: Template[] }>("/templates"),
  get: (id: string) => apiFetch<Template>(`/templates/${id}`),
  create: (data: Omit<Template, "createdAt" | "updatedAt">) =>
    apiFetch<Template>("/templates", { method: "POST", body: JSON.stringify(data) }),
  update: (id: string, data: Partial<Template>) =>
    apiFetch<Template>(`/templates/${id}`, { method: "PATCH", body: JSON.stringify(data) }),
  remove: (id: string) => apiFetch<void>(`/templates/${id}`, { method: "DELETE" }),
  preview: (id: string, variables: Record<string, unknown>) =>
    apiFetch<{ subject: string; html: string; text?: string }>(
      `/templates/${id}/preview`,
      { method: "POST", body: JSON.stringify({ variables }) },
    ),
};
